import type { TFunction } from 'i18next'
import {
  LEX_REGULATORY_NEWS_TOPIC_DOMAIN,
  type RegulatoryNewsCategory,
} from '@/shared/hooks/api/regulatoryNews'

/** English labels from server `LEX_REGULATORY_NEWS_TOPICS` (identity for API/DB). */
const LEX_TOPIC_ID_BY_ENGLISH_LABEL: Record<string, string> = {
  Automotive: 'automotive',
  'Industrial Policy': 'industrial-policy',
  'Type Approval': 'type-approval',
  'Emissions Regulation': 'emissions-regulation',
  'Product liability': 'product-liability',
  Sanctions: 'sanctions',
  Tariffs: 'tariffs',
}

export function resolveLexRegulatoryNewsTopicId(
  category: RegulatoryNewsCategory
): string | undefined {
  if (category.domain !== LEX_REGULATORY_NEWS_TOPIC_DOMAIN) {
    return undefined
  }
  return LEX_TOPIC_ID_BY_ENGLISH_LABEL[category.label.trim()]
}

export function getRegulatoryNewsTopicDisplayLabel(
  category: RegulatoryNewsCategory,
  translate: TFunction<'regulatory-alerts'>
): string {
  const topicId = resolveLexRegulatoryNewsTopicId(category)
  if (topicId) {
    return translate(`topics.${topicId}`, category.label)
  }
  return category.label
}
